function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTableWidget = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 50,
  viewBox: "0 0 128 100"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M112 92H16a8 8 0 0 1-8-8V20a8 8 0 0 1 8-8h96a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8Zm-28-4h28a4 4 0 0 0 4-4V72H84v16Zm0-20h32V52H84v16ZM48 88h32V72H48v16Zm0-20h32V52H48v16Zm32-20V32H48v16h32ZM12 84a4 4 0 0 0 4 4h28V72H12v12Zm0-16h32V52H12v16Zm0-20h32V32H12v16Zm104-28a4 4 0 0 0-4-4H16a4 4 0 0 0-4 4v8h104v-8ZM84 32v16h32V32H84Z",
  style: {
    fillRule: "evenodd"
  }
}));
SvgTableWidget.displayName = "SvgTableWidget";
export { SvgTableWidget as ReactComponent };
export default SvgTableWidget;